import NewWebProfileDropdown from "@components/store/navigation/ProfileDropdown/web";
import NewResponsiveProfileDropdown from "@components/store/navigation/ProfileDropdown/responsive";

import withResponsiveToggle from "@stadium/ui/src/hoc/responsive-toggle";

import { getStadiumSharedConfig } from "@helpers/config";

import { StadiumSharedConfigWrapper } from "@stadium/shared/global-config";

const NewProfileDropdown = withResponsiveToggle({
  WebView: NewWebProfileDropdown,
  ResponsiveView: NewResponsiveProfileDropdown,
});

const WrappedProfileDropdown = () => (
  <StadiumSharedConfigWrapper value={getStadiumSharedConfig}>
    <NewProfileDropdown />
  </StadiumSharedConfigWrapper>
);

export default WrappedProfileDropdown;
